import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: 1px solid #ccc;\n  width: 25px;\n  border-radius: 50%;\n\n  &:hover {\n    background: #ccc;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import useTheme from "hooks/useTheme";
import Svg from "../Svg";
var CsSvg = styled(Svg).withConfig({
    componentId: "sc-f5db5303-0"
})(_templateObject());
var Icon = function(props) {
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(CsSvg, _object_spread_props(_object_spread({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: theme.isDark ? "#fff" : "#000",
            d: "M8.71005 11.71L11.3001 14.3C11.6901 14.69 12.3201 14.69 12.7101 14.3L15.3001 11.71C15.9301 11.08 15.4801 10 14.5901 10H9.41005C8.52005 10 8.08005 11.08 8.71005 11.71Z"
        })
    }));
};
export default Icon;
